import React from "react";
import Article from "../Article";

const Event = () => {
  return <Article type="Event" title="Sự kiện"></Article>;
};

export default Event;
